/*
  ORIBIO — Entradas reveal / stagger (sin librerías)
  Uso:
    - data-oribio-reveal          → el elemento entra con fade + translateY.
    - data-oribio-stagger         → sus hijos directos entran escalonados
                                    (80ms entre cada uno; opcional
                                    data-oribio-stagger="120" para otro paso).
  Respeta prefers-reduced-motion: si está activo (o no hay
  IntersectionObserver), no se oculta nada y no hay movimiento.
*/
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('oribio-revealed');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  function init(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-oribio-stagger]').forEach(function (container) {
      var step = parseInt(container.getAttribute('data-oribio-stagger'), 10) || 80;
      Array.prototype.forEach.call(container.children, function (child, i) {
        if (!child.hasAttribute('data-oribio-reveal')) {
          child.setAttribute('data-oribio-reveal', '');
        }
        child.style.setProperty('--oribio-reveal-delay', i * step + 'ms');
      });
    });

    var targets = scope.querySelectorAll('[data-oribio-reveal]:not(.oribio-revealed)');
    if (!targets.length) return;

    document.documentElement.classList.add('oribio-reveal-enabled');
    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Si el usuario activa "reducir movimiento" con la página abierta, todo visible.
  var onMotionChange = function (event) {
    if (!event.matches) return;
    document.documentElement.classList.remove('oribio-reveal-enabled');
    observer.disconnect();
  };
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', onMotionChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor: re-inicializa las secciones recargadas.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
